@if (showMissingCategoryWarning) {
  <section class="vc-admin-form vc-admin-product-form vc-admin-form--category-warning">
    @if (showIntro) {
      <header class="vc-admin-form__intro">
        <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
        <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
      </header>
    }

    <section class="vc-admin-form__section">
      <div class="vc-admin-form__warning">
        <i class="fas fa-triangle-exclamation"></i>
        <p>{{ "ADMIN.FORMS.PRODUCT.CATEGORY_REQUIRED" | translate }}</p>
      </div>

      <a
        [routerLink]="['/administration', customer_route_param, 'products', 'categories', 'new']"
        class="vc-admin-form__category-link"
      >
        {{ "ADMIN.FORMS.PRODUCT.CREATE_CATEGORY_ACTION" | translate }}
      </a>
    </section>
  </section>
} @else {
  <form class="vc-admin-form vc-admin-product-form" (ngSubmit)="execute()">
    @if (showIntro) {
      <header class="vc-admin-form__intro">
        <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
        <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
      </header>
    }

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.PRODUCT.TITLE" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.FORMS.PRODUCT.DETAIL_HINT" | translate }}
    </p>

    <div class="grid">
      <div class="col-12 md:col-7">
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="field">
              <label for="product-name">{{ "COMMON.PRODUCT.NAME" | translate }} *</label>
              <input
                id="product-name"
                pInputText
                pSize="small"
                name="name"
                [(ngModel)]="payload.name"
                fluid
              />
              <small class="p-error" *ngIf="errors.name">{{ errors.name | translate }}</small>
            </div>
          </div>

          <div class="col-12 md:col-6">
            <div class="field">
              <label for="product-category">{{ "COMMON.PRODUCT.CATEGORY.NAME" | translate }}</label>
              <p-select
                id="product-category"
                name="products_categories_id"
                size="small"
                [options]="productsCategories"
                [(ngModel)]="payload.products_categories_id"
                optionLabel="name"
                optionValue="id"
                appendTo="body"
                fluid
              ></p-select>
            </div>
          </div>

          <div class="col-12">
            <div class="field">
              <label for="product-description">{{ "COMMON.PRODUCT.DESCRIPTION" | translate }}</label>
              <input
                id="product-description"
                pInputText
                pSize="small"
                name="description"
                [(ngModel)]="payload.description"
                fluid
              />
              <small class="p-error" *ngIf="errors.description">
                {{ errors.description | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.PRODUCT.IMAGE" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.FORMS.PRODUCT.IMAGE_HINT" | translate }}
    </p>

    <div class="grid">
      <div class="col-12 md:col-4">
        <div class="vc-admin-product-form__image-preview">
          <app-product-image [image_url]="imagePreviewUrl"></app-product-image>
        </div>
      </div>
      <div class="col-12 md:col-8">
        <div class="field">
          <label for="product-image-upload">{{ "COMMON.PRODUCT.IMAGE" | translate }}</label>
          <input
            id="product-image-upload"
            class="vc-admin-product-form__file-input"
            type="file"
            accept="image/*"
            (change)="onImageSelected($event)"
          />
          <small class="vc-admin-product-form__file-help">
            {{ "ADMIN.FORMS.PRODUCT.IMAGE_UPLOAD_HELP" | translate }}
          </small>
          <small class="vc-admin-product-form__file-name" *ngIf="selectedImageName">
            {{ selectedImageName }}
          </small>
          <small class="p-error" *ngIf="imageUploadFailed">
            {{ "ADMIN.FORMS.PRODUCT.IMAGE_UPLOAD_PARTIAL_DETAIL" | translate }}
          </small>
        </div>
      </div>
    </div>
  </section>

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.COLOR" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.FORMS.PRODUCT.COLOR_HINT" | translate }}
    </p>

    <div class="field">
      <label for="product-color">{{ "COMMON.PRODUCT.COLOR" | translate }}</label>
      <div class="vc-admin-color-control">
        <div class="vc-admin-color-control__inputs">
          <input
            id="product-color"
            class="vc-admin-color-control__picker"
            type="color"
            [value]="colorPreview"
            (input)="onColorInput($any($event.target).value)"
          />
          <input
            pInputText
            [value]="colorPreview"
            (input)="onColorInput($any($event.target).value)"
          />
        </div>

        <div class="vc-admin-color-control__presets">
          @for (preset of colorPresets; track preset) {
            <button
              type="button"
              class="vc-admin-color-control__preset"
              [class.is-active]="preset === colorPreview"
              [style.background]="preset"
              [attr.aria-label]="('COMMON.COLOR' | translate) + ' ' + preset"
              (click)="selectColorPreset(preset)"
            ></button>
          }
        </div>
      </div>
      <small class="vc-admin-color-control__hint">
        {{ "ADMIN.FORMS.PRODUCT.COLOR_HINT" | translate }}
      </small>
      <small class="p-error" *ngIf="errors.color">{{ errors.color | translate }}</small>
    </div>
  </section>

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.PRICE.BASE" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.FORMS.PRODUCT.PRICE_HINT" | translate }}
      <strong *ngIf="basePriceCurrencyLabel"> ({{ basePriceCurrencyLabel }})</strong>
    </p>

    <div class="field">
      <label for="product-base-price">
        {{ "COMMON.PRICE.BASE" | translate }}
        <span *ngIf="basePriceCurrencyLabel">({{ basePriceCurrencyLabel }})</span>
        *
      </label>
      <p-inputnumber
        inputId="product-base-price"
        size="small"
        name="basePrice"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [(ngModel)]="payload.basePrice"
        fluid
      />
    </div>
    <small class="p-error" *ngIf="errors.basePrice">{{ errors.basePrice | translate }}</small>
  </section>

  @if (mode === 'create') {
    <section class="vc-admin-form__section">
      <h4 class="vc-admin-form__section-title">{{ "ADMIN.FORMS.ASSIGNMENT.TITLE" | translate }}</h4>
      <p class="vc-admin-form__section-subtitle">
        {{ "ADMIN.FORMS.ASSIGNMENT.SUBTITLE" | translate }}
      </p>

      <div class="vc-admin-form__warning">
        <i class="fas fa-triangle-exclamation"></i>
        <p>{{ "ADMIN.FORMS.ASSIGNMENT.WARNING" | translate }}</p>
      </div>

      <div class="vc-admin-assignment-options">
        <label class="vc-admin-assignment-options__item" for="product-save-manual">
          <p-radioButton
            inputId="product-save-manual"
            name="productSaveMode"
            value="manual"
            [(ngModel)]="saveMode"
          />
          <span>
            <strong>{{ "ADMIN.FORMS.ASSIGNMENT.MANUAL_TITLE" | translate }}</strong>
            <small>{{ "ADMIN.FORMS.ASSIGNMENT.MANUAL_DESCRIPTION" | translate }}</small>
          </span>
        </label>

        <label class="vc-admin-assignment-options__item" for="product-save-all">
          <p-radioButton
            inputId="product-save-all"
            name="productSaveMode"
            value="all-clinics"
            [(ngModel)]="saveMode"
          />
          <span>
            <strong>{{ "ADMIN.FORMS.ASSIGNMENT.ALL_TITLE" | translate }}</strong>
            <small>{{ "ADMIN.FORMS.ASSIGNMENT.ALL_DESCRIPTION" | translate }}</small>
          </span>
        </label>
      </div>
    </section>
  }

    <app-admin-form-actions
      primaryLabelKey="COMMON.SAVE"
      [submitting]="submitting"
    ></app-admin-form-actions>
  </form>
}
